export function usePopup(initialState?: boolean) {
  const visibility = ref(Boolean(initialState))

  const open = () => (visibility.value = true)
  const close = () => (visibility.value = false)
  const toggle = () => (visibility.value = !visibility.value)

  return { visibility: readonly(visibility), open, close, toggle }
}
